function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 18,
  fill: "#F5841F"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 11C14.134 11 11 14.134 11 18V19H12.5C12.7761 19 13 19.2239 13 19.5V25.5C13 25.7761 12.7761 26 12.5 26H12C10.8954 26 10 25.1046 10 24V18C10 13.5817 13.5817 10 18 10C22.4183 10 26 13.5817 26 18V24C26 25.1046 25.1046 26 24 26H23.5C23.2239 26 23 25.7761 23 25.5V19.5C23 19.2239 23.2239 19 23.5 19H25V18C25 14.134 21.866 11 18 11ZM18.5 18.5C18.5 18.2239 18.2761 18 18 18C17.7239 18 17.5 18.2239 17.5 18.5V25.5C17.5 25.7761 17.7239 26 18 26C18.2761 26 18.5 25.7761 18.5 25.5V18.5ZM15.5 20C15.7761 20 16 20.2239 16 20.5V24.5C16 24.7761 15.7761 25 15.5 25C15.2239 25 15 24.7761 15 24.5V20.5C15 20.2239 15.2239 20 15.5 20ZM21 20.5C21 20.2239 20.7761 20 20.5 20C20.2239 20 20 20.2239 20 20.5V24.5C20 24.7761 20.2239 25 20.5 25C20.7761 25 21 24.7761 21 24.5V20.5Z",
  fill: "white"
});

function SvgSpy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpy);
export default __webpack_public_path__ + "static/media/spy.2e8e7305.svg";
export { ForwardRef as ReactComponent };